// import library
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import moment from "moment/moment";
import Swal from "sweetalert2";
// import components
import Layout from "../../layouts/Layout";
import NewsPagination from "../../components/Dashboard/NewsPagination";
import TableLoaderIcon from "../../components/Common/Icon/TableLoader";
import CommentForm from "../../components/Dashboard/CommentForm";
import ReplyForm from "../../components/Dashboard/ReplyForm";
import EditForm from "../../components/Dashboard/EditForm";
import LoaderIcon from "../../components/Common/Icon/Loader";

// import files
import { env } from "../../env";
import { AuthContext } from "../../context";
import { logEvent } from "../../analytics";

const Dashboard = () => {
    // variables
    const { t } = useTranslation();
    const authContext = useContext(AuthContext);
    const currentDate = new Date();
    const [isLoader, setIsLoader] = useState(true);

    const [rowNewsCurrentPage, setNewsCurrentPage] = useState(1);
    const [rowsNewsPerPage, setNewsRowsPerPage] = useState(5);

    const [sortName, setSortName] = useState('desc');
    const [showSort, setShowSort] = useState(false);
    const [showNewsInDetail, setShowNewsInDetail] = useState(false);
    const [isTableLoader, setIsTableLoader] = useState(false);
    const [newsTabId, setNewsTabId] = useState(1);
    const [newsTabName, setNewsTabName] = useState("Offers");
    const [activeNewsId, setActiveNewsId] = useState(0);
    const [isActiveMark, setIsActiveMark] = useState(false);
    const [isShowActiveArrow, setIsShowActiveArrow] = useState(false);
    const [commentAction, setCommentAction] = useState(false);
    const [showBox, setShowBox] = useState("comment");
    const [isLiked, setIsLiked] = useState(false);
    const isAdmin = parseInt(localStorage.getItem('isAdmin'));
    const [commentDataId, setCommentDataId] = useState(0);
    const [commentParentId, setCommentParentId] = useState(0);
    const [commentContent, setCommentContent] = useState("");
    const [viewComment, setViewComment] = useState(false);
    const [viewCommentId, setViewCommentId] = useState(0);

    const [defaultProductImage, setDefaultProductImage] = useState("");
    const [categories, setCategories] = useState([]);
    const [categoryArticle, setCategoryArticles] = useState({
        "total_records": 0,
        "articles": []
    });

    useEffect(() => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        const fetchData = async () => {
            await getDefaultProductImage(baseUrl, token);
            await getCategoriesApi(baseUrl, token);
        };
        fetchData();
    }, []);

    // functions
    const getCategoriesApi = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+"/api/Product/GetNewsArticlesCategories",{ headers })
        .then((response) => {
            if(response.data) {
                setCategories(response.data);
                setIsLoader(false);
                if(response.data.length > 0) {
                    setIsTableLoader(true);
                    getCategoryArticleApi(url, token, newsTabId, rowNewsCurrentPage, sortName, 'first');
                }
            }
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const getCategoryArticleApi = async (url, token, categoryId, page, sort, type) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+`/api/Product/GetNewsArticlesListBasedOnCategory?categoryId=${categoryId}&page_num=${page}&ordertype=${sort}`,{ headers })
        .then((response) => {
            const readBox = [];
            if(response.data.articles) {
                setCategoryArticles(response.data);
                if(response.data.articles.length > 0) {
                    handleNewsInDetail(response.data.articles[0].article_id, response.data.articles[0].IsRead);
                }
                response.data.articles.map((article, index) => {
                    readBox.push(article.IsRead);
                });

                if(readBox.includes(false)){
                    setIsActiveMark(true);
                    if(type === 'first') {
                        setIsShowActiveArrow(true);
                    } else {
                        setIsShowActiveArrow(false);
                    }
                } else {
                    setIsActiveMark(false);
                    if(type === 'first') {
                        setIsShowActiveArrow(false);
                    }
                }
            } else {
                setCategoryArticles({
                    "total_records": 0,
                    "articles": []
                })
                setIsActiveMark(false);
                if(type === 'first') {
                    setIsShowActiveArrow(false);
                }
            }
            setIsTableLoader(false);
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const getDefaultProductImage = async (url, token) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.get(url+"/api/User/GetDefaultImage",{ headers })
        .then((response) => {
            setDefaultProductImage(response.data.productDefaultImage);
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const markAllRead = async (url, token, id) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.post(url+ "/api/Product/UpdateReadFlagForDashboardNews", {
            "article_id": id
        }, { headers }).then((response) => {
            if(response.data.success === true) {
                getCategoryArticleApi(url, token, newsTabId, rowNewsCurrentPage, sortName, 'second');
                if(id === 'all') {
                    setIsActiveMark(false);
                    Swal.fire({
                        position: "top-end",
                        icon: "success",
                        title: `${ t("marked all as read")}!`,
                        showConfirmButton: false,
                        timer: 1500
                    });
                }
            }
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });

    };
    const addNewComment = async (url, token, data, status) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.post(url+ "/api/Product/InsertNewsArticleComments", data, { headers })
        .then((response) => {
            if(response.data.success === true) {
                getCategoryArticleApi(url, token, newsTabId, rowNewsCurrentPage, sortName, 'second');
                setShowBox('comment');
                setCommentDataId(0);
                if(status === 'update') {
                    Swal.fire({
                        title: `${ t("comment updated")}!`,
                        text: `${ t("your comment is updated")}!`,
                        icon: "success"
                    });
                }  else if(status === 'reply') {
                    Swal.fire({
                        title: `${ t("reply added")}!`,
                        text: `${ t("your reply is added")}!`,
                        icon: "success"
                    });
                } else {
                    Swal.fire({
                        title: `${ t("comment added")}!`,
                        text: `${ t("your comment is added")}!`,
                        icon: "success"
                    });
                }
            }
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const likeArticle = async (url, token, data) => {
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };
        axios.post(url+ "/api/product/InsertNewsArticleLike", data, { headers })
        .then((response) => {
            getCategoryArticleApi(url, token, newsTabId, rowNewsCurrentPage, sortName, 'second');
        }).catch((error) => {
            console.log(error);
            if(error.response && (error.response.status === 401 || error.response.status === 404)) {
                localStorage.removeItem("token");
                localStorage.removeItem("userInfo");
                window.location.reload();
            }
        });
    };
    const handleNewsTab = (e, tab) => {
        e.preventDefault();
        logEvent('dashboard_page', 'article', 'tab_change', tab);
        setNewsTabId(tab.category_id);
        setNewsTabName(tab.name);
        setCategoryArticles({
            "total_records": 0,
            "articles": []
        });
        setIsTableLoader(true);
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        getCategoryArticleApi(baseUrl, token, tab.category_id, rowNewsCurrentPage, sortName, 'second');
    };
    const handleAllRead = (e) => {
        e.preventDefault();
        logEvent('dashboard_page', 'article', 'marked_all_read', 'read-all');
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        markAllRead(baseUrl, token, 'all');
    };
    const handleNewsCurrentPage = (page) => {
        logEvent('dashboard_page', 'article', 'pagination', page);
        setNewsCurrentPage(page);
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        setIsTableLoader(true);
        getCategoryArticleApi(baseUrl, token, newsTabId, page, sortName, 'second');
    };
    const handleNewsInDetail = (id, read) => {
        logEvent('dashboard_page', 'article', 'single_article_read', id);
        if(activeNewsId === id) {
            setShowNewsInDetail(!showNewsInDetail);
        } else {
            setShowNewsInDetail(true);
        }
        setActiveNewsId(id);
        if(!read) {
            const baseUrl = env.REACT_APP_API_URL;
            const token = localStorage.getItem('token');
            markAllRead(baseUrl, token, id);
        }
    };
    const handleCommentAction = (e, commentId) => {
        e.preventDefault();
        setShowBox('comment');
        if(commentDataId === commentId) {
            setCommentAction(!commentAction);
        } else {
            setCommentAction(true);
        }
        setCommentDataId(commentId);
    };
    const handleReply = (e, commentId) => {
        e.preventDefault();
        setShowBox('reply');
        setCommentDataId(commentId);
    };
    const handleEdit = (e, comment) => {
        e.preventDefault();
        setShowBox('edit');
        setCommentDataId(comment.ID);
        setCommentContent(comment.Comment);
        setCommentParentId(comment.ParentID);
        setCommentAction(false);
    };
    const handleReplyBoxCloseFromChild = (data) => {
        setShowBox(data);
        setCommentDataId(0);
    };
    const handleEditBoxCloseFromChild = (data) => {
        setShowBox(data);
    };
    const handleCommentRequestFromChild = (data) => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        logEvent('dashboard_page', 'article', 'comment', data);

        Swal.fire({
            title: `${ t("are you sure?")}`,
            text: `${ t("you want to add comment")}!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `${ t("yes")}!`,
            cancelButtonText: `${ t("cancel")}!`
        }).then((result) => {
            if (result.isConfirmed) {
                addNewComment(baseUrl, token, data, 'new');
            }
        });
    };
    const handleReplyRequestFromChild = (data) => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        logEvent('dashboard_page', 'article', 'reply', data);
        Swal.fire({
            title: `${ t("are you sure?")}`,
            text: `${ t("you want to reply")}!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `${ t("yes")}!`,
            cancelButtonText: `${ t("cancel")}!`
        }).then((result) => {
            if (result.isConfirmed) {
                addNewComment(baseUrl, token, data, 'reply');
            }
        });
    };
    const handleEditRequestFromChild = (data) => {
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        logEvent('dashboard_page', 'article', 'edit_comment', data);

        Swal.fire({
            title: `${ t("are you sure?")}`,
            text: `${ t("you want to edit your comment")}!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `${ t("yes")}!`,
            cancelButtonText: `${ t("cancel")}!`
        }).then((result) => {
            if (result.isConfirmed) {
                addNewComment(baseUrl, token, data, 'update');
            }
        });
    };
    const handleSort = (e, data) => {
        e.preventDefault();
        logEvent('dashboard_page', 'article', 'sort', data);
        setSortName(data);
        setShowSort(!showSort);
        setIsTableLoader(true);
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        getCategoryArticleApi(baseUrl, token, newsTabId, rowNewsCurrentPage, data, 'second');
    };
    const handleNewsPerPage = (row) => {
        setNewsRowsPerPage(row);
    };
    const handleLikeButton = (e, article ,index) => {
        e.preventDefault();
        if(article.IsLiked) {
            var like = false
        } else {
            var like = true
        }
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        let requestData = {
            "NewsArticlesID" : article.article_id,
            "IsLiked" : like
        };
        likeArticle(baseUrl, token, requestData);
    };
    const handleViewReplies = (e, commentId) => {
        e.preventDefault();
        if(viewCommentId === commentId) {
            setViewComment(!viewComment);
            if(viewComment) {
                setViewCommentId(0); 
            } else {
                setViewCommentId(commentId); 
            }
        } else {
            setViewComment(true);
            setViewCommentId(commentId);
        }
    };

    return (
        <Layout>
            <div className="space-y-2 sm:space-y-4">
                <div className="flex justify-between items-center">
                    <div>
                        <h1 className="lg:text-2xl font-semibold capitalize">{ t('overview')}</h1>
                        <p className="text-light-400 text-sm capitalize"> { t('dashboard') } / { t('overview')}</p>
                    </div>
                </div>
                {
                    isLoader
                    ?
                        <LoaderIcon />
                    :
                    <div className="space-y-2 sm:space-y-4">
                        <div className={((categoryArticle.articles.length > 0 && isShowActiveArrow) ? "h-[4.5rem] overflow-hidden" : "") + " border border-white bg-white shadow-around rounded-xl p-2 sm:p-4 space-y-3"}>
                            <div className="sm:flex sm:justify-between sm:items-center space-y-2 sm:space-y-0">
                                <div className="flex space-x-2 sm:space-x-4 items-center">
                                    {categories.length > 0 ?
                                        categories.map((tab, index) => (
                                            <div key={`tab${tab.category_id}`} onClick={(e) => handleNewsTab(e, tab)} className={( newsTabId === tab.category_id ? 'bg-blue-light text-blue-normal' : 'text-gray-dark') + " cursor-pointer text-xs sm:text-base py-2 px-2 sm:px-4 text-center rounded-lg capitalize font-semibold"}>{tab.name}</div>
                                        ))
                                    : null}
                                </div>
                                { categoryArticle.articles.length > 0 ? 
                                    <div className="text-xs sm:text-base flex justify-end sm:justify-between lg:justify-normal space-x-2 sm:space-x-4 items-center">
                                        <div onClick={(e) => isActiveMark ? handleAllRead(e) : null} className={(isActiveMark ? "cursor-pointer text-blue-normal" : "cursor-not-allowed text-gray-dark") + " text-center rounded-lg first-letter:capitalize font-semibold"}>{ t('mark all as read')}</div>
                                        <div className="cursor-pointer relative text-light-400 text-center rounded-lg capitalize font-semibold flex" onClick={(e) => setShowSort(!showSort)}>
                                            <div className="mr-2">{ sortName === 'desc' ? t('latest') : t('oldest')}</div>
                                            <img src="../../../assets/icons/table/sort-arrow-down.svg" alt="arrow" />  
                                            { showSort ? 
                                                <div className="absolute w-fit top-6 right-0 z-10 text-background-dark bg-white shadow-md rounded-md">
                                                    <ul>
                                                        <li key="latest" onClick={(e) => handleSort((e), 'desc')}  className="bg-white hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize">{ t('latest')}</li>
                                                        <li key="oldest" onClick={(e) => handleSort((e), 'asc')}  className="bg-white hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize">{ t('oldest')}</li>
                                                    </ul> 
                                                </div>
                                            : null }  
                                        </div>
                                        <div className="cursor-pointer" onClick={(e) => setIsShowActiveArrow(!isShowActiveArrow)}><img className="w-3 h-3 sm:w-4 sm:h-4" src="../../assets/icons/select-down.svg" alt="select-down" /></div>
                                    </div>
                                : null }
                            </div>
                            <div className="bg-news-normal rounded-md py-2 sm:p-4 space-y-3">
                                { isTableLoader
                                    ?
                                        <TableLoaderIcon />
                                    :
                                        categoryArticle.articles.length > 0 ?
                                            categoryArticle.articles.map((article, index) => (
                                                <div key={`article${article.article_id}`} className={((showNewsInDetail && activeNewsId === article.article_id) ? "sm:flex" : "flex") + (!article.IsRead ? "bg-yellow-light border-news-border1" : " bg-white border-news-border" )+ " bg-white border-news-border space-x-1 sm:space-x-3 border rounded-md p-2"}>
                                                    <div className={((showNewsInDetail && activeNewsId === article.article_id) && "items-center sm:items-start") + " flex flex-col"}>
                                                        <img className={ ((showNewsInDetail && activeNewsId === article.article_id) ? "sm:h-48 sm:w-48" : "h-16 w-16") + " rounded max-w-fit sm:max-w-none"} src={article.Image1 ? article.Image1 : defaultProductImage} alt="image" />
                                                    </div>
                                                    <div className="flex flex-col w-full pr-1 py-2 space-y-3">
                                                        <div className="flex justify-between w-full">
                                                            <h1 className="font-bold text-xs sm:text-sm">{article.title}</h1>
                                                            <img onClick={(e) => handleNewsInDetail(article.article_id, article.IsRead)} className="cursor-pointer w-3 h-3" src={`../../../assets/icons/table/sort-arrow-${(showNewsInDetail && activeNewsId === article.article_id) ? 'up' : 'down'}.svg`} alt="arrow" /> 
                                                        </div>
                                                        <div className="flex items-center">
                                                            <div className={((showNewsInDetail && activeNewsId === article.article_id)? 'w-[90%]' : 'line-clamp-1') + " text-xs sm:text-sm"} dangerouslySetInnerHTML={{ __html: article.content }}></div>
                                                            { (showNewsInDetail && activeNewsId === article.article_id && newsTabName === 'Offers') ? 
                                                                (!isAdmin) ? 
                                                                    <div className="flex flex-col justify-between items-center w-[10%] ml-4">
                                                                        <div onClick={(e) => handleLikeButton(e, article, index)} className="bg-background-normal rounded-full p-1 flex justify-center cursor-pointer">
                                                                            <img className="p-2" src={`../../../assets/icons/dashboard/heart-${article.IsLiked ? 'red' : 'white'}.svg`} alt="heart" />
                                                                        </div>
                                                                    </div>
                                                                : null
                                                                // <div className="flex flex-col justify-between items-center w-16 ml-4">
                                                                //     <div className="bg-background-normal rounded-full p-1 flex justify-center cursor-pointer">
                                                                //         <img className="p-2" src={`../../../assets/icons/dashboard/heart-red.svg`} alt="heart" />
                                                                //     </div>
                                                                //     <div className="text-xs">200 Likes</div>
                                                                // </div>
                                                            : null}
                                                        </div>
                                                        {(showNewsInDetail && activeNewsId === article.article_id) ?
                                                            newsTabName !== 'Offers' ?
                                                                <div className="sm:flex space-x-1 sm:space-x-0 sm:justify-between sm:items-center">
                                                                    <div className="sm:flex space-x-1 sm:space-x-2 text-xs italic"><span className="first-letter:capitalize text-light-400">{ t('published by')}</span> <span className="font-bold">{article.username} </span><span className="text-light-400">{ t('on')}</span><span className="font-bold">{ moment(article.publication_date).format('Do MMMM YYYY')}</span></div>
                                                                    {(!isAdmin) ? 
                                                                        <div className="flex flex-col justify-center items-center">
                                                                            <div onClick={(e) => handleLikeButton(e, article)} className="bg-background-normal rounded-full p-2.5 flex justify-center cursor-pointer">
                                                                                <img src={`../../../assets/icons/dashboard/heart-${article.IsLiked ? 'red' : 'white'}.svg`} alt="heart" />
                                                                            </div>
                                                                        </div>
                                                                    : null
                                                                        // <div className="flex flex-col justify-between items-center w-16 ml-4">
                                                                        //     <div className="bg-background-normal rounded-full p-1 flex justify-center cursor-pointer">
                                                                        //         <img className="p-2" src={`../../../assets/icons/dashboard/heart-red.svg`} alt="heart" />
                                                                        //     </div>
                                                                        //     <div className="text-xs">200 Likes</div>
                                                                        // </div>
                                                                    }
                                                                </div>
                                                            : null
                                                        : null}
                                                        {(showNewsInDetail && activeNewsId === article.article_id) ? <div className="border-t border-background-normal"></div> : null }
                                                        {(showNewsInDetail && activeNewsId === article.article_id) &&
                                                            ((!isAdmin) ? 
                                                                <div className="space-y-3">
                                                                    {((article?.comments.length > 0) ?
                                                                        <div className={((article.comments.length > 3) ? "h-40 overflow-y-scroll": "") + " space-y-3"}>
                                                                            {article.comments.map((comment, index1) => (
                                                                                <div key={`comment${comment.ID}`} className="flex items-start w-full">
                                                                                    <div className="p-1 sm:p-3 rounded-full bg-sky-light w-max">
                                                                                        <img className="w-2 h-2 sm:w-3 sm:h-3" src="../../../assets/icons/dashboard/profile.svg" alt="profile"/>
                                                                                    </div>
                                                                                    <div className="ml-1 sm:ml-2 w-full">
                                                                                        <div className="sm:flex space-x-1 sm:space-x-2 text-[10px] sm:text-xs">
                                                                                            <span className="font-bold capitalize">{ t('you')}</span> <span className="text-light-400">{ t('commented on')}</span><span className="font-bold">{ moment(comment.CreatedOn).format('Do MMMM YYYY')}</span>
                                                                                            <div className="ml-3 relative">
                                                                                                <div className="p-1 cursor-pointer">
                                                                                                    <img onClick={(e) => handleCommentAction(e, comment.ID)} src="../../../assets/icons/dashboard/dots-vertical.svg" alt="dot" />
                                                                                                </div>
                                                                                                {(commentAction && commentDataId === comment.ID) ?
                                                                                                    <div className="absolute w-max left-8 z-40 -top-2 bg-white border border-white shadow-md rounded-md">
                                                                                                        <ul>
                                                                                                            <li onClick={(e) => handleEdit(e, comment)} className="hover:bg-action-hover px-4 py-1.5 hover:rounded-t capitalize flex cursor-pointer">
                                                                                                                <img className="mr-2" src="../../../assets/icons/dashboard/edit.svg" alt="edit" />{ t('edit') }
                                                                                                            </li>
                                                                                                            <li className="hover:bg-action-hover px-4 py-1.5 hover:rounded-t capitalize flex cursor-pointer">
                                                                                                                <img className="mr-2" src="../../../assets/icons/dashboard/delete.svg" alt="delete" />{ t('delete') }
                                                                                                            </li>
                                                                                                        </ul>
                                                                                                    </div>
                                                                                                : null }
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="text-[10px] sm:text-xs">
                                                                                            {comment.Comment ? comment.Comment : "--"}
                                                                                        </div>
                                                                                        {comment.Replies && 
                                                                                            (viewComment && viewCommentId === comment.ID) &&
                                                                                                comment.Replies.map((reply, index2) => (
                                                                                                    <div key={`comment${reply.ID}`} className="flex items-start rounded-xl bg-news-normal p-2.5 w-full mt-3">
                                                                                                        <div className="p-3 rounded-full bg-gray-dark2">
                                                                                                            <img className="w-3 h-3" src="../../../assets/icons/dashboard/admin.svg" alt="admin"/>
                                                                                                        </div>
                                                                                                        <div className="ml-2 space-y-1">
                                                                                                            <div className="flex space-x-2 text-[10px] sm:text-xs">
                                                                                                                <span className="font-bold capitalize">{(authContext.userInfo.userName === reply.UserName) ? t('you') : reply.Name}</span> <span className="capitalize text-light-400">{ t('replied')}</span><span className="font-bold">{ moment(reply.CreatedOn).format('Do MMMM YYYY')}</span>
                                                                                                            </div>
                                                                                                            <div className="text-[10px] sm:text-xs">
                                                                                                                {reply.Comment}
                                                                                                            </div>
                                                                                                            {(showBox !== 'reply' || commentDataId !== comment.ID) ? <div onClick={(e) => handleReply(e, comment.ID)} className="capitalize text-light-400 font-semibold text-[10px] cursor-pointer">{ t('reply')}</div> : null}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                )
                                                                                            )
                                                                                        }
                                                                                        {comment.Replies && 
                                                                                            <div className="text-[10px] sm:text-xs cursor-pointer font-medium text-light-400" onClick={(e) => handleViewReplies(e, comment.ID)}>
                                                                                                {(viewCommentId !== comment.ID) ? 'view replies' : 'hide replies'}
                                                                                            </div>
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                        : 
                                                                        <div className="text-center font-bold text-xs sm:text-lg capitalize">
                                                                            { t('no comments yet')}
                                                                        </div>
                                                                    )}
                                                                    {(showBox === 'comment') ? <div><CommentForm article={article.article_id} sendCommentRequestFromChild={handleCommentRequestFromChild}/></div> : null}
                                                                    {(showBox === 'reply') ? <div><ReplyForm article={article.article_id} commentId={commentDataId} comment={commentContent} sendReplyRequestFromChild={handleReplyRequestFromChild} sendReplyBoxCloseFromChild={handleReplyBoxCloseFromChild} /></div> : null}
                                                                    {(showBox === 'edit') ? <div><EditForm article={article.article_id} commentId={commentDataId} parentId={commentParentId} comment={commentContent} sendEditRequestFromChild={handleEditRequestFromChild} sendEditBoxCloseFromChild={handleEditBoxCloseFromChild} /></div> : null}
                                                                </div>
                                                                :
                                                                <div className="space-y-3">
                                                                    {((article?.comments.length > 0) ?
                                                                        <div className={((article.comments.length > 3) ? "h-40 overflow-y-scroll": "") + " space-y-3"}>
                                                                            { article.comments.map((comment, index1) => (
                                                                                <div key={`comment${comment.ID}`} className="flex items-start w-full">
                                                                                    <div className="p-1 sm:p-3 rounded-full bg-sky-light w-max">
                                                                                        <img className="w-2 h-2 sm:w-3 sm:h-3" src="../../../assets/icons/dashboard/profile.svg" alt="profile"/>
                                                                                    </div>
                                                                                    <div className="ml-1 sm:ml-2 w-full">
                                                                                        <div className="sm:flex space-x-1 sm:space-x-2 text-[10px] sm:text-xs">
                                                                                            <span className="font-bold capitalize">{ comment.Name }</span>
                                                                                            <span className="text-light-400">{ t('commented on')}</span>
                                                                                            <span className="font-bold">{ moment(comment.CreatedOn).format('Do MMMM YYYY')}</span>
                                                                                        </div>
                                                                                        <div className="text-[10px] sm:text-xs">
                                                                                            {comment.Comment ? comment.Comment : "--"}
                                                                                        </div>
                                                                                        {(commentDataId !== comment.ID) ? 
                                                                                            <div onClick={(e) => handleReply(e, comment.ID)} className="capitalize text-light-400 font-semibold text-[10px] cursor-pointer">{ t('reply')}</div> 
                                                                                            : 
                                                                                            <div className="mt-3"><ReplyForm article={article.article_id} commentId={commentDataId} comment={commentContent} sendReplyRequestFromChild={handleReplyRequestFromChild} sendReplyBoxCloseFromChild={handleReplyBoxCloseFromChild} /></div> 
                                                                                        }
                                                                                        {comment.Replies && 
                                                                                            (viewComment && viewCommentId === comment.ID) &&
                                                                                                comment.Replies.map((reply, index2) => (
                                                                                                    <div key={`comment${reply.ID}`} className="flex items-start rounded-xl bg-news-normal p-2.5 w-full mt-3">
                                                                                                        <div className="p-3 rounded-full bg-gray-dark2">
                                                                                                            <img className="w-3 h-3" src="../../../assets/icons/dashboard/admin.svg" alt="admin"/>
                                                                                                        </div>
                                                                                                        <div className="ml-2 space-y-1">
                                                                                                            <div className="sm:flex space-x-1 sm:space-x-2 text-[10px] sm:text-xs">
                                                                                                                <span className="font-bold">{(authContext.userInfo.userName === reply.UserName) ? t('you') : reply.Name}</span> <span className="capitalize text-light-400">{ t('replied')}</span><span className="font-bold">{ moment(reply.CreatedOn).format('Do MMMM YYYY')}</span>
                                                                                                                <div className="ml-3 relative">
                                                                                                                    <div className="p-1 cursor-pointer">
                                                                                                                        <img onClick={(e) => handleCommentAction(e, reply.ID)} src="../../../assets/icons/dashboard/dots-vertical.svg" alt="dot" />
                                                                                                                    </div>
                                                                                                                    {(commentAction && commentDataId === reply.ID) &&
                                                                                                                        <div className="absolute w-max left-8 z-40 -top-14 bg-white border border-white shadow-md rounded-md">
                                                                                                                            <ul>
                                                                                                                                <li onClick={(e) => handleEdit(e, reply)} className="hover:bg-action-hover px-4 py-1.5 hover:rounded-t capitalize flex cursor-pointer">
                                                                                                                                    <img className="mr-2" src="../../../assets/icons/dashboard/edit.svg" alt="edit" />{ t('edit') }
                                                                                                                                </li>
                                                                                                                                <li className="hover:bg-action-hover px-4 py-1.5 hover:rounded-t capitalize flex cursor-pointer">
                                                                                                                                    <img className="mr-2" src="../../../assets/icons/dashboard/delete.svg" alt="delete" />{ t('delete') }
                                                                                                                                </li>
                                                                                                                            </ul>
                                                                                                                        </div>
                                                                                                                    }
                                                                                                                </div>
                                                                                                            </div>
                                                                                                            <div className="text-xs">
                                                                                                                {(showBox === 'edit' && commentDataId === reply.ID) ? <div><EditForm article={article.article_id} commentId={commentDataId} parentId={commentParentId} comment={commentContent} sendEditRequestFromChild={handleEditRequestFromChild} sendEditBoxCloseFromChild={handleEditBoxCloseFromChild} /></div> : reply.Comment}
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                )
                                                                                            )
                                                                                        }
                                                                                        {comment.Replies ? 
                                                                                            <div className="text-xs cursor-pointer font-medium text-light-400" onClick={(e) => handleViewReplies(e, comment.ID)}>
                                                                                                {(viewCommentId !== comment.ID) ? 'view replies' : 'hide replies'}
                                                                                            </div>
                                                                                            : null
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                        : 
                                                                        <div className="text-center font-bold text-xs sm:text-lg capitalize">
                                                                            { t('no comments yet')}
                                                                        </div>)
                                                                    }
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            ))
                                        :
                                        <div className="py-4 text-center font-bold text-xs sm:text-xl capitalize">
                                            { t(newsTabName.toLowerCase() + ' not available')}
                                        </div>
                                }
                            </div>
                            <div>
                               <NewsPagination 
                                    currentPage={rowNewsCurrentPage}
                                    totalCount={categoryArticle.total_records}
                                    pageSize={rowsNewsPerPage}
                                    onPageChange={page => handleNewsCurrentPage(page)}
                                    onPageSizeChange={row => handleNewsPerPage(row)}
                                />
                            </div>
                        </div>
                    </div>
                }
            </div>
        </Layout>
    )
}

export default Dashboard;